import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemingService {
  org: string = '';

  constructor() {
    this.org = document.body.getAttribute('data-theme');
  }

  public getOrganizationName(): string {
    switch(this.org) {
      case "ffpeds":
        return "Families First Pediatrics";
      case "weecare":
        return "Wee Care Pediatrics";
      default:
        throw new Error("Invalid theme");
    }
  }
}
